module.exports = __webpack_public_path__ + "img/w3_bookmark_solid_light.d708dca6.png";